// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { PartnerDetailResponse } from "./types";

import * as partnerActions from "./partner.actions";

export function* getPartner(
  action: ReturnType<typeof partnerActions.getDetailPartnerAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = `${BASE_URL}partner/${action.payload.id}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: PartnerDetailResponse = yield call(result.json.bind(result));
      yield put(partnerActions.getDetailPartnerAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(partnerActions.getDetailPartnerAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(partnerActions.getDetailPartnerAsync.failure(parsed));
  }
}

export default function* partnerSagaGetPartner() {
  yield takeEvery(partnerActions.getDetailPartnerAsync.request, getPartner);
}
